import { AxiosError } from "axios";
import { handleApiError } from "./instanceApi";
import { moodleInstanceApi } from "./moodleInstanceApi";

export const getLiveClasses = async (params: any) => {
  try {
    const response = await moodleInstanceApi.get(
      "/webservice/rest/server.php",
      {
        params: {
          wsfunction: "mod_bigbluebuttonbn_get_bigbluebuttonbns_by_courses",
          ...params,
        },
      }
    );
    return response?.data;
  } catch (error) {
    console.error("Error fetching calendar events:", error);
    return handleApiError(error as AxiosError);
  }
};

export const checkLiveClassCanJoin = async (cmid: any) => {
  try {
    const response = await moodleInstanceApi.get(
      "/webservice/rest/server.php",
      {
        params: {
          wsfunction: "mod_bigbluebuttonbn_can_join ",
          cmid: cmid,
        },
      }
    );
    return response?.data;
  } catch (error) {
    console.error("Error fetching calendar events:", error);
    return handleApiError(error as AxiosError);
  }
};
